/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 * @generated-id: 377859f3f79a
 */

import * as z from "zod";
import { ApiError, ApiError$zodSchema } from "./apierror.js";
import {
  MessageResponse,
  MessageResponse$zodSchema,
} from "./messageresponse.js";
import {
  UpdateTriggerRequest,
  UpdateTriggerRequest$zodSchema,
} from "./updatetriggerrequest.js";

export type UpdateTriggerGlobals = { cloud_name?: string | undefined };

export const UpdateTriggerGlobals$zodSchema: z.ZodType<UpdateTriggerGlobals> = z
  .object({
    cloud_name: z.string().describe(
      "The cloud name of your product environment.",
    ).optional(),
  });

export type UpdateTriggerRequestRequest = {
  id: string;
  update_trigger_request: UpdateTriggerRequest;
};

export const UpdateTriggerRequestRequest$zodSchema: z.ZodType<
  UpdateTriggerRequestRequest
> = z.object({
  id: z.string().describe("The ID of the trigger."),
  update_trigger_request: UpdateTriggerRequest$zodSchema.describe(
    "The updated trigger configuration.",
  ),
});

export type UpdateTriggerResponse = MessageResponse | ApiError;

export const UpdateTriggerResponse$zodSchema: z.ZodType<UpdateTriggerResponse> =
  z.union([
    MessageResponse$zodSchema,
    ApiError$zodSchema,
  ]);
